module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-green.21daef7c.webp";